import { createTheme } from '@mantine/core'

export const theme = createTheme({
  primaryColor: 'orange',
  colors: {
    orange: [
      '#fff6f0', // primary-1
      '#ffe8db', // primary-2
      '#ffcbb3', // primary-3
      '#ffa98c', // interpolated
      '#ff8861', // primary-5
      '#f46036', // primary (main)
      '#f4633a', // tomato-50
      '#f68261', // tomato-40
      '#d14d2a', // darker
      '#a83d22', // darkest
    ],
  },
})
